import { numberFormat, unitToString } from '@/utils/unitUtils';

const formatQuantity = (quantity, digits = 2) => {
  if (!quantity || quantity.scalar == null) return null;
  return `${numberFormat(quantity.scalar, digits)} ${unitToString(quantity.unit) || ''}`.trim();
};

const formatFactor = factor => {
  if (factor == null) return null;
  return numberFormat(factor, factor < 10 ? 3 : 1);
};

export const buildTransformationSubtitle = transformations => {
  if (!transformations) return null;
  const {
    cost_reference_year: costRefYear,
    analysis_start_year: analysisYear,
    inflation_rate: inflationRate,
    inflation_factor: inflationFactor,
    plant_capacity: plantCapacity,
    reference_capacity: referenceCapacity,
    scaling_exponent: scalingExponent,
    scaling_factor: scalingFactor,
  } = transformations;

  const scalingApplies = scalingFactor != null && scalingFactor !== 1;
  const yearMessage =
    costRefYear === analysisYear
      ? `Inputs are already in ${analysisYear} dollars; no inflation applied.`
      : `Costs entered in ${costRefYear} dollars are inflated to ${analysisYear} dollars at ${
          inflationRate ? `${numberFormat(inflationRate.scalar, 2)}%/yr` : 'the project inflation rate'
        } (× ${formatFactor(inflationFactor)}).`;

  const scalingMessage = scalingApplies
    ? `Costs are scaled from a reference capacity of ${formatQuantity(referenceCapacity)} to the plant capacity of ${formatQuantity(
        plantCapacity,
      )} using an exponent of ${scalingExponent ? numberFormat(scalingExponent.scalar, 2) : '1.0'} (× ${formatFactor(scalingFactor)}).`
    : null;

  return `${scalingMessage ? `${scalingMessage} ` : ''}${yearMessage}`;
};
